import React from 'react'
import { Link } from "react-router-dom"
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import CardUI from '../../../widgets/layout/CardUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import './EventListPage.css'

const EventListPageUI = ({ context, account, eventLogList, onRefreshClick, onDetailsClick, details }) =>
  <SuperUserAccountPageUI context={context} className='pg_su_events' backLink='/su/accounts' dimension='w768'
    headerText={account && account.accountName} centered={!eventLogList} account={account} page='events'
  >
    {
      !eventLogList &&
      <SpinnerComponentUI />
    }
    {
      eventLogList &&
      <EventLogMonthListUI
        context={context}
        eventLogMonthList={eventLogList}
        onRefreshClick={onRefreshClick}
        onDetailsClick={onDetailsClick}
        details={details}
      />
    }
  </SuperUserAccountPageUI>

const EventLogMonthListUI = ({ context, eventLogMonthList, onRefreshClick, onDetailsClick, details }) =>
  <div>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Event Logs</b></span>
        </div>
      }
      right={
        <span>
          <Link to='#' onClick={onDetailsClick}>Details</Link>
        </span>
      }
    />
    {
      eventLogMonthList.map((eventLogMonth, i) =>
        <CardUI key={i} title={eventLogMonth.yearMonth} className='g_m_bottom_100' noUnderline={true}>
          <EventLogListUI context={context} eventLogList={eventLogMonth.eventLogList} details={details} />
        </CardUI>
      )
    }
  </div>

const EventLogListUI = ({ context, eventLogList, details }) =>
  <LRTableBodyUI className='g_m_top_25'>
    {
      eventLogList.filter(e => e.eventType !== 'loan_status_update_in_console').map((eventLog, i) =>
        <EventLogRowUI key={i} context={context} eventLog={eventLog} details={details} />
      )
    }
  </LRTableBodyUI>

const EventLogRowUI = ({ context, eventLog, details }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<RowLeftUI context={context} eventLog={eventLog} details={details} />}
    right={<RowRightUI eventLog={eventLog} details={details} />}
  />

const RowLeftUI = ({ context, eventLog, details }) =>
  <div className='g_flex_v'>
    <span className='g_flex_v'>
      <span><b>
        {eventLog.eventLabel}
        {
          eventLog.recurrence > 1 &&
          <span className='g_m_left_100 g_muted'>{eventLog.recurrence} times</span>
        }
      </b></span>
      <span className='g_muted'>{eventLog.dateCreatedF} IST</span>
    </span>
    {
      details &&
      <>
        {
          eventLog.eventType === 'email_to_client' &&
          <span className='g_m_top_25'>
            Subject: {eventLog.emailSubject}
            <div dangerouslySetInnerHTML={{ __html: eventLog.emailMessage }} />
          </span>
        }
        {
          eventLog.eventDetails &&
          <span>{eventLog.eventDetails}</span>
        }
        {
          eventLog.userName &&
          <span className='g_muted'>By: {eventLog.userName}</span>
        }
        <span className='g_muted g_small'>Internal Ref: {eventLog.ecid} {eventLog.ipAddress}</span>
      </>
    }
  </div>

const RowRightUI = ({ context, eventLog, details }) =>
  <>
    {
      !details && eventLog.amountF2 &&
      <span className='g_flex_v g_flex_right g_text_right'>
        {eventLog.amountF2}
        <span className='g_muted'>{eventLog.amountLabel}</span>
      </span>
    }
    {
      details &&
      <table><tbody>
        {
          eventLog.amountF2 &&
          <tr>
            <td className='label g_muted'>{eventLog.amountLabel}</td>
            <td className='chomp'>{eventLog.amountF2}</td>
          </tr>
        }
        {
          Object.entries(eventLog.payLoadMap).map(([key, value]) =>
            <tr key={key}>
              <td className='label g_muted'>{key}</td>
              <td className='chomp'><span>{value}</span>
              </td></tr>
          )
        }
      </tbody></table>
    }
  </>

export default EventListPageUI
